import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
interface StatsOverviewProps {
  period: string;
}
const statsData: Record<string, any[]> = {
  today: [{
    label: 'Interventions auto-déclenchées',
    value: '85%',
    change: '+65%',
    trend: 'up',
    target: 'Objectif: ≥85%'
  }, {
    label: 'Respect des SLA',
    value: '94%',
    change: '+24%',
    trend: 'up',
    target: 'Objectif: ≥95%'
  }, {
    label: 'Véhicules actifs',
    value: '67/80',
    change: '0',
    trend: 'neutral',
    target: 'En opération'
  }, {
    label: 'Écart facturation',
    value: '0.4%',
    change: '-1.6%',
    trend: 'up',
    target: 'Objectif: <0.5%'
  }],
  week: [{
    label: 'Interventions auto-déclenchées',
    value: '88%',
    change: '+68%',
    trend: 'up',
    target: 'Objectif: ≥85%'
  }, {
    label: 'Respect des SLA',
    value: '96%',
    change: '+26%',
    trend: 'up',
    target: 'Objectif: ≥95%'
  }, {
    label: 'Véhicules actifs',
    value: '72/80',
    change: '+5',
    trend: 'up',
    target: 'En opération'
  }, {
    label: 'Écart facturation',
    value: '0.3%',
    change: '-1.7%',
    trend: 'up',
    target: 'Objectif: <0.5%'
  }]
};
export function StatsOverview({
  period
}: StatsOverviewProps) {
  const stats = statsData[period] || statsData.today;
  return <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-623">
      {stats.map((stat, index) => <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 hover:shadow-md transition-shadow cursor-pointer" data-id="element-624">
          <div className="flex items-center justify-between" data-id="element-625">
            <p className="text-sm font-medium text-gray-600" data-id="element-626">{stat.label}</p>
            {stat.trend === 'up' && <TrendingUp className="w-4 h-4 text-green-500" data-id="element-627" />}
            {stat.trend === 'down' && <TrendingDown className="w-4 h-4 text-red-500" data-id="element-628" />}
            {stat.trend === 'neutral' && <Minus className="w-4 h-4 text-gray-400" data-id="element-629" />}
          </div>
          <div className="mt-2" data-id="element-630">
            <p className="text-3xl font-bold text-gray-900" data-id="element-631">{stat.value}</p>
            <div className="flex items-center space-x-2 mt-1" data-id="element-632">
              <span className={`text-sm font-medium ${stat.trend === 'up' ? 'text-green-600' : stat.trend === 'down' ? 'text-red-600' : 'text-gray-500'}`} data-id="element-633">
                {stat.change}
              </span>
              <span className="text-xs text-gray-500" data-id="element-634">{stat.target}</span>
            </div>
          </div>
        </div>)}
    </div>;
}